// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";

const HERO = document.querySelector(".swiper-container--hero");
const SLIDESHOW = document.querySelector(".swiper-container--slideshow");

// init hero swiper
if (HERO && HERO.querySelectorAll(".swiper-slide").length > 1) {
    new Swiper (HERO, {
        modules: [Autoplay, EffectFade, Navigation, Pagination],
        autoplay: {
            delay: 7500,
        },
        effect: "fade",
        loop: true,
        navigation: {
            nextEl: HERO.querySelector(".swiper-button--next"),
            prevEl: HERO.querySelector(".swiper-button--prev"),
        },
        pagination: {
            el: HERO.querySelector(".swiper-pagination"),
            clickable: true,
        },
        speed: 150,
    });
}

// init slideshow swiper
if (SLIDESHOW && SLIDESHOW.querySelectorAll(".swiper-slide").length > 1) {
    new Swiper (SLIDESHOW, {
        modules: [Autoplay, EffectFade, Navigation, Pagination],
        autoplay: {
            delay: 7500,
        },
        effect: "fade",
        loop: true,
        navigation: {
            nextEl: SLIDESHOW.querySelector(".swiper-button--next"),
            prevEl: SLIDESHOW.querySelector(".swiper-button--prev"),
        },
        pagination: {
            el: SLIDESHOW.querySelector(".swiper-pagination"),
            clickable: true,
        },
        speed: 150,
    });
}
